(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-contact-flow]').forEach((flow) => {
    const choice = flow.querySelector('[data-contact-form-choice]');
    const panel = flow.querySelector('[data-contact-form-panel]');

    if (!choice || !panel) return;

    const hasFormMessage = panel.querySelector('.contact-form__error, .contact-form__success');

    if (!hasFormMessage) {
      panel.hidden = true;
    } else {
      choice.setAttribute('aria-expanded', 'true');
    }

    choice.addEventListener('click', (event) => {
      event.preventDefault();
      panel.hidden = false;
      choice.setAttribute('aria-expanded', 'true');
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });

      const firstField = panel.querySelector('input:not([type="hidden"]), select, textarea');
      if (firstField) firstField.focus({ preventScroll: true });
    });
  });

  document.querySelectorAll('[data-contact-phone]').forEach((input) => {
    input.addEventListener('input', () => {
      const startsWithPlus = input.value.startsWith('+');
      const digits = input.value.replace(/\D/g, '').slice(0, 15);

      input.value = startsWithPlus ? `+${digits}` : digits;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
